































import { Component, Vue, Watch } from 'vue-property-decorator';
import MelosStations from '@/views/MelosStations.vue';
import MelosContentCollection from '@/views/MelosContentCollection.vue';
import MelosDevices from '@/views/MelosDevices.vue';
import MelosTabbar from '@/components/MelosTabbar.vue';
import { MelosDeviceType, MelosDevice } from '@/services/api.service';
import askarImage from '@/assets/askar.png';
import transmitterImage from '@/assets/transmitter.png';
import MelosButtonSet from '@/components/MelosButtonSet.vue';
import _ from 'lodash';

export interface VOnsTab {
  icon?: string;
  label: string;
  page: any;
  key: string;
}

@Component({
  components: {
    MelosTabbar,
    MelosButtonSet,
  },
})
export default class Home extends Vue {

  private defaultTab: string = 'stations';
  private debouncedVolumeUpdate = _.debounce(this.updateVolume, 500);

  private mounted() {
    if (this.activeTab === 'home') {
      this.activeTab = this.defaultTab;
    }
  }

  private get connectedDevice(): string | undefined {
    return this.$store.state.connectedDevice;
  }

  private get volume(): number {
    return this.$store.state.player?.volume || 50;
  }

  private set volume(level: number) {
    this.$store.commit('setPlayerData', { volume: level });
  }

  @Watch('volume')
  private onVolumeChanged() {
    this.debouncedVolumeUpdate();
  }

  private updateVolume() {
    if (this.connectedDevice === undefined) {
      return;
    }

    this.$melosControllerService.sendCommand('SET_VOLUME', [String(this.volume)]);
  }

  private get connectedDeviceData(): MelosDevice {
    return this.$store.state.ownedDevices.find((data: any) => {
      return data.device_id === this.connectedDevice;
    });
  }

  private get connectedDeviceLogo() {
    return this.connectedDeviceData.type === MelosDeviceType.STANDALONE ? askarImage : transmitterImage;
  }

  private handleDeviceOptionsClick(index: number) {
    switch (index) {
      case 0:
        this.disconnectFromDevice();
        break;
      case 1:
        this.$melosControllerService.sendCommand('GET_STATIONS', []);
        break;
      case 2:
        this.$melosControllerService.sendCommand('TURNOFF', []);
        break;
    }
  }

  private disconnectFromDevice() {
    this.$melosControllerService.disconnect();
  }

  private get activeTab(): string {
    return this.$route.name || '';
  }

  private set activeTab(tabId: string) {
    this.$router.push({ path: `/home/${tabId}` });
  }

  private get tabs(): VOnsTab[] {
    const tabList: VOnsTab[] = [
      {
        label: 'Stations',
        page: MelosStations,
        key: 'stations',
      },
    ];
    if (![undefined, ''].includes(this.$store.state.session?.token)) {
      tabList.push({
        label: 'My collection',
        page: MelosContentCollection,
        key: 'collection',
      });
      tabList.push({
        label: 'My devices',
        page: MelosDevices,
        key: 'devices',
      });
    }
    return tabList;
  }
}
